import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, Define,
    ValidationMessage, SettingState, ValidationMessageType,
    SettingControlType,
} from '@appblocks/codegeneration/types';
import Setting from '@appblocks/codegeneration/SettingsConfigurations/settings/Setting';
import LUISItem from '@appblocks/codegeneration/SettingsConfigurations/LUISItem';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';

export default class DSMAN extends BaseFeature {
    constructor() {
        super();
        this.name = 'DS Manager';
        this.id = 'ds_man';
        this.icon = 'MdOutlineSpaceDashboard';
        this.requirements = ['tios'];
        this.fileLinks = [

        ];
        this.files = [
            'libraries/utils/flags.tbh',
            'libraries/utils/flags.tbs',
            'libraries/utils/login_control.tbh',
            'libraries/utils/login_control.tbs',
            'libraries/dsman/net_cmd.tbh',
            'libraries/dsman/net_cmd.tbs',
            'sdf.xtxt',
        ];

        const settings = [
            {
                id: 'ENABLED',
                name: 'DS Manager Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                helpText: `Manage settings from a PC. 
Download the DS manager tool here:
[DS Manager](https://tibbo.com/support/downloads/tdst.html)`,
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'GROUPS',
                name: 'Groups',
                settingType: SettingType.ARRAY,
                refId: 'luis_group',
                controlType: SettingControlType.TABS,
                required: true,
                helpText: 'Will appear as tabs on the DS Manager interface',
                default: new Array<BaseFeature>(0),
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDefines(): Array<Define> {
        const defines = [];
        let count = 0;
        const groups = this.getSettingValue('GROUPS');
        let tmpBlocks: Array<CodeBlock> = [];
        for (let i = 0; i < groups.length; i += 1) {
            const group = groups[i];
            count += 1;
            tmpBlocks = tmpBlocks.concat(group.getCodeBlocks());
        }
        for (let i = 0; i < tmpBlocks.length; i += 1) {
            switch (tmpBlocks[i].location) {
                case 'sdf.xtxt':
                    count += 1;
                    break;
                default:

                    break;
            }
        }
        defines.push({
            name: 'MAX_NUM_SDF_LINES',
            value: count.toString(),
        });

        return defines;
    }

    getDependencies() {
        const dependencies = [
            'stg',
            'sock',
            'fd',
        ];

        return dependencies;
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];

        const groups = this.getSettingValue('GROUPS');
        let group;
        for (let i = 0; i < groups.length; i += 1) {
            if (groups[i].getID() === 'GEN') {
                group = groups[i];
            }
        }

        const { project } = this;
        let dnFound = false;
        let onFound = false;
        let pwFound = false;
        for (let i = 0; i < project.features.length; i += 1) {
            if (project.features[i].id === 'stg') {
                const settingArray = project.features[i].getSettingValue('SETTINGS');
                for (let j = 0; j < settingArray.length; j += 1) {
                    const settingID = settingArray[j].getSettingValue('SETTINGID');
                    if (settingID === 'DN') dnFound = true;
                    if (settingID === 'ON') onFound = true;
                    if (settingID === 'PW') pwFound = true;
                }
                if (!dnFound) {
                    const dnSetting = new Setting();
                    dnSetting.initSettings(project);
                    dnSetting.setSettingValue('SETTINGID', 'DN');
                    dnSetting.setSettingValue('NAME', 'Device Name');
                    dnSetting.setSettingValue('MAX', '8');
                    errors.push({
                        messageType: ValidationMessageType.ADD,
                        message: '',
                        featureId: project.features[i].getID(),
                        settingId: 'SETTINGS',
                        data: FeatureUtils.toJson(dnSetting),
                    });
                    const dsGroupsArray = this.getSettingValue('GROUPS');
                    for (let j = 0; j < dsGroupsArray.length; j += 1) {
                        if (dsGroupsArray[j].getSettingValue('ITEMID') === 'GEN') {
                            const dnLuisItem = new LUISItem();
                            dnLuisItem.initSettings(project);
                            dnLuisItem.setSettingValue('SETTINGID', 'DN');
                            dnLuisItem.setSettingValue('NAME', 'Device Name');
                            errors.push({
                                messageType: ValidationMessageType.ADD,
                                message: '',
                                featureId: dsGroupsArray[j].getID(),
                                settingId: 'SETTINGS',
                                data: FeatureUtils.toJson(dnLuisItem),
                            });
                        }
                    }
                }
                if (!onFound) {
                    const onSetting = new Setting();
                    onSetting.initSettings(project);
                    onSetting.setSettingValue('SETTINGID', 'ON');
                    onSetting.setSettingValue('NAME', 'Owner Name');
                    onSetting.setSettingValue('MAX', '8');
                    errors.push({
                        messageType: ValidationMessageType.ADD,
                        message: '',
                        featureId: project.features[i].getID(),
                        settingId: 'SETTINGS',
                        data: FeatureUtils.toJson(onSetting),
                    });
                    const dsGroupsArray = this.getSettingValue('GROUPS');
                    for (let j = 0; j < dsGroupsArray.length; j += 1) {
                        if (dsGroupsArray[j].getSettingValue('ITEMID') === 'GEN') {
                            const onLuisItem = new LUISItem();
                            onLuisItem.initSettings(project);
                            onLuisItem.setSettingValue('SETTINGID', 'ON');
                            onLuisItem.setSettingValue('NAME', 'Owner Name');
                            errors.push({
                                messageType: ValidationMessageType.ADD,
                                message: '',
                                featureId: dsGroupsArray[j].getID(),
                                settingId: 'SETTINGS',
                                data: FeatureUtils.toJson(onLuisItem),
                            });
                        }
                    }
                }
                if (!pwFound) {
                    const pwSetting = new Setting();
                    pwSetting.initSettings(project);
                    pwSetting.setSettingValue('DEFAULT', '^');
                    pwSetting.setSettingValue('SETTINGID', 'PW');
                    pwSetting.setSettingValue('NAME', 'Password');
                    pwSetting.setSettingValue('MAX', '16');
                    errors.push({
                        messageType: ValidationMessageType.ADD,
                        message: '',
                        featureId: project.features[i].getID(),
                        settingId: 'SETTINGS',
                        data: FeatureUtils.toJson(pwSetting),
                    });
                    const dsGroupsArray = this.getSettingValue('GROUPS');
                    for (let j = 0; j < dsGroupsArray.length; j += 1) {
                        if (dsGroupsArray[j].getSettingValue('ITEMID') === 'GEN') {
                            const onLuisItem = new LUISItem();
                            onLuisItem.initSettings(project);
                            onLuisItem.setSettingValue('SETTINGID', 'PW');
                            errors.push({
                                messageType: ValidationMessageType.ADD,
                                message: '',
                                featureId: dsGroupsArray[j].getID(),
                                settingId: 'SETTINGS',
                                data: FeatureUtils.toJson(onLuisItem),
                            });
                        }
                    }
                }
            }
        }
        return errors;
    }

    getState(settingId: string): SettingState {
        if (settingId !== 'ENABLED' && this.getSettingValue('ENABLED').toString() === '0') {
            return SettingState.HIDDEN;
        }
        switch (settingId) {
            case 'ENABLED':
                return SettingState.ENABLED;
            default:
                return SettingState.ENABLED;
        }
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];
        if (this.getSettingValue('ENABLED').toString() === '0') {
            return blocks;
        }

        const settingsFile = '';
        let tmpBlocks: Array<CodeBlock> = [];
        const groups = this.getSettingValue('GROUPS');
        let sdfFile = '';
        for (let i = 0; i < groups.length; i += 1) {
            const group = groups[i];
            tmpBlocks = tmpBlocks.concat(group.getCodeBlocks());
        }
        for (let i = 0; i < tmpBlocks.length; i += 1) {
            switch (tmpBlocks[i].location) {
                case 'sdf.xtxt':
                    sdfFile += tmpBlocks[i].template;
                    break;
                default:

                    break;
            }
        }


        blocks.push({
            location: 'SDF_XTXT',
            blockType: BlockType.CODE,
            template: `${sdfFile}\r\n`,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.LOCATION,
            id: 'callback_login_event',
            template: `
sub callback_login_event(mode as cmd_modes)
    '****callback_login_event****'
end sub
            `,
        });

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.CODE,
            template: `
function callback_get_timeout(mode as cmd_modes) as word

    select case mode
    case CMD_MODE_NONE:

    case CMD_MODE_UDP:
        goto get_timeout
    case else
get_timeout:
        callback_get_timeout=LOGIN_TIMEOUT
    end select
        
end function
            `,
        });

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    net_cmd_init()
    init_x_flags()`,
        });

        blocks.push({
            location: 'on_sock_data_arrival',
            blockType: BlockType.CODE,
            template: `
    net_cmd_proc(CMD_MODE_UDP,error_mode)
            `,
        });

        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/soism/ds_manager';
    }
}
